import React from "react";
import Users from "../../Organizations/Users/Users";

const GovernanceFramework = () => {
  return <Users governance={true} expandList={true} org={true}/>;
};

export default GovernanceFramework;

// import React from "react";
// import {
//   Card,
//   CardContent,
//   CardHeader,
//   CardTitle,
// } from "../../../components/ui/card";
// import {
//   Tabs,
//   TabsList,
//   TabsTrigger,
//   TabsContent,
// } from "../../../components/ui/tabs";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   PieChart,
//   Pie,
//   Cell,
//   LineChart,
//   Line,
//   Rectangle,
//   CartesianGrid,
// } from "recharts";
// import BootstrapTable from "react-bootstrap-table-next";
// import {
//   TableClasses,
//   TableWrapClasses,
//   TDClasses,
//   THClasses,
//   TRClasses,
// } from "../../../config";
// import MainBody from "../../../components/MainBody/MainBody";
// import {
//   ChartContainer,
//   ChartLegend,
//   ChartLegendContent,
//   ChartTooltip,
//   ChartTooltipContent,
// } from "../../../components/ui/chart";
// import { cn } from "../../../lib/utils";
// import { ArrowUpRight } from "lucide-react";

// // ---------------- MOCK DATA ----------------
// const riskData = [
//   { name: "Low", value: 60 },
//   { name: "Medium", value: 30 },
//   { name: "High", value: 10 },
// ];

// const alertTrend = [
//   { name: "Jan", alerts: 300 },
//   { name: "Feb", alerts: 420 },
//   { name: "Mar", alerts: 380 },
//   { name: "Apr", alerts: 450 },
// ];

// const alertTypes = [
//   { name: "Structuring", value: 120 },
//   { name: "Unusual", value: 200 },
//   { name: "Sanctions", value: 130 },
// ];

// const COLORS = ["#22c55e", "#facc15", "#ef4444"];

// // ---------------- MAIN DASHBOARD ----------------
// export default function GovernanceFramework() {
//   return (
//     <MainBody search={false} loading={false} expandList={true}>
//       <div className="space-y-6">
//         <Header />
//         <KpiRow />

//         <Tabs defaultValue="risk">
//           <TabsList className="flex lg:w-fit w-full lg:justify-center h-auto justify-start gap-2 overflow-x-auto lg:flex-nowrap hide-scrollbar">
//             <TabsTrigger value="risk">Risk</TabsTrigger>
//             <TabsTrigger value="alerts">Alerts</TabsTrigger>
//             <TabsTrigger value="cases">Cases</TabsTrigger>
//             <TabsTrigger value="kyc">KYC</TabsTrigger>
//             <TabsTrigger value="compliance">Compliance</TabsTrigger>
//           </TabsList>

//           <TabsContent value="risk">
//             <RiskSection />
//           </TabsContent>

//           <TabsContent value="alerts">
//             <AlertsSection />
//           </TabsContent>

//           <TabsContent value="cases">
//             <CaseSection />
//           </TabsContent>

//           <TabsContent value="kyc">
//             <KycSection />
//           </TabsContent>

//           <TabsContent value="compliance">
//             <ComplianceSection />
//           </TabsContent>
//         </Tabs>
//       </div>
//     </MainBody>
//   );
// }

// // ---------------- HEADER ----------------
// function Header() {
//   return (
//     <div className="flex justify-between items-center">
//       <h1 className="text-2xl font-bold">AML/CTF Dashboard</h1>
//       <div className="flex gap-2">
//         <input type="date" className="border p-2 rounded" />
//         <input type="date" className="border p-2 rounded" />
//       </div>
//     </div>
//   );
// }

// // ---------------- KPI ----------------
// function KpiRow() {
//   return (
//     <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//       <KPI title="High Risk" value="120" status="high" />
//       <KPI title="Open Alerts" value="450" status="medium" />
//       <KPI title="SAR Filed" value="35" status="low" />
//       <KPI title="KYC %" value="98%" status="John" />
//     </div>
//   );
// }

// // ---------------- KPI ----------------
// function KPI({ title, value, status, subtitle, onClick }) {
//   const statusStyles = {
//     high: {
//       indicator: "bg-red-500",
//       badge: "bg-red-50 text-red-600",
//     },
//     medium: {
//       indicator: "bg-yellow-500",
//       badge: "bg-yellow-50 text-yellow-600",
//     },
//     low: {
//       indicator: "bg-green-500",
//       badge: "bg-green-50 text-green-600",
//     },
//     default: {
//       indicator: "bg-webPrimary",
//       badge: "bg-webPrimary text-white",
//     },
//   };

//   const currentStatus = statusStyles[status] || statusStyles.default;

//   return (
//     <Card
//       onClick={onClick}
//       className={cn(
//         "group relative cursor-pointer overflow-hidden",
//         "rounded-xl border",
//         "shadow-sm transition-all duration-200 ease-in-out",
//         "hover:-translate-y-1 hover:border-webPrimary",
//         "hover:bg-webSecondary hover:text-white hover:shadow-md",
//         "active:translate-y-0",
//         "p-0",
//       )}
//     >
//       <div className="p-4">
//         {/* Header */}
//         <div className="flex items-start justify-between gap-2">
//           <div>
//             <span className="py-1.5 text-md font-medium">
//               {title}
//             </span>
//           </div>

//           {/* Status */}
//           <span
//             className={cn(
//               "rounded-md px-2 py-1 text-[11px] font-medium capitalize",
//               currentStatus.badge,
//             )}
//           >
//             {status}
//           </span>
//         </div>

//         {/* Value */}
//         <div className="mt-3 flex items-end justify-between">
//           <div>
//             <h2 className="text-2xl font-bold leading-none tracking-tight">
//               {value}
//             </h2>

//             {subtitle && (
//               <p className="mt-2 text-[11px] text-webPrimary">{subtitle}</p>
//             )}
//           </div>

//           {/* Hover arrow */}
//           <ArrowUpRight
//             className={cn(
//               "h-5 w-5 text-gray-400",
//               "transition-all duration-200",
//               "group-hover:translate-x-0.5",
//               "group-hover:-translate-y-0.5",
//               "group-hover:text-webPrimary",
//               "group-hover:opacity-100",
//             )}
//           />
//         </div>
//       </div>
//     </Card>
//   );
// }
// // ---------------- RISK ----------------
// function RiskSection() {
//   var pieChartConfig = {};

//   for (let i = 0; i < riskData?.length; i++) {
//     pieChartConfig[`${riskData[i]?.name}`] = {
//       label: riskData[i]?.name,
//     };
//   }
//   return (
//     <div className="grid md:grid-cols-2 gap-6">
//       <Card>
//         <CardHeader>
//           <CardTitle>Risk Distribution</CardTitle>
//         </CardHeader>
//         <CardContent>
//           <ChartContainer
//             config={pieChartConfig}
//             className="mx-auto max-h-[250px]"
//           >
//             <PieChart>
//               <ChartTooltip
//                 content={
//                   <ChartTooltipContent
//                     nameKey="name"
//                     hideLabel
//                     formatter={(value, name, item, index) => (
//                       <>
//                         <div
//                           className="h-2.5 w-2.5 shrink-0 rounded-[2px] bg-[var(--color-bg)]"
//                           style={{
//                             "--color-bg": `${
//                               COLORS[
//                                 riskData?.findIndex(
//                                   (item) =>
//                                     item.value === value && item.name === name,
//                                 ) % COLORS.length
//                               ]
//                             }`,
//                           }}
//                         />
//                         {riskData[name]?.label || name}
//                         <div className="ml-auto flex items-baseline gap-0.5 font-mono font-medium tabular-nums text-foreground">
//                           {`${value}%`}
//                         </div>
//                       </>
//                     )}
//                   />
//                 }
//               />
//               <Pie
//                 data={riskData}
//                 dataKey="value"
//                 label={({ payload, ...props }) => {
//                   return (
//                     <text
//                       cx={props.cx}
//                       cy={props.cy}
//                       x={props.x}
//                       y={props.y}
//                       textAnchor={props.textAnchor}
//                       dominantBaseline={props.dominantBaseline}
//                       fill={COLORS[props?.index % COLORS.length]}
//                     >
//                       {`${payload.value}`}
//                     </text>
//                   );
//                 }}
//               >
//                 {riskData?.map((entry, index) => (
//                   <Cell
//                     key={`cell-${index}`}
//                     fill={COLORS[index % COLORS.length]}
//                   />
//                 ))}
//               </Pie>
//               <ChartLegend
//                 content={<ChartLegendContent nameKey="name" />}
//                 className="-translate-y-2 flex-wrap gap-2 [&>*]:basis-1/4 [&>*]:justify-center flex-col items-start inline-flex max-w-44"
//                 verticalAlign="bottom"
//                 align="right"
//                 layout="vertical"
//               />
//             </PieChart>
//           </ChartContainer>
//         </CardContent>
//       </Card>

//       <Card>
//         <CardHeader>
//           <CardTitle>Top Risk Customers</CardTitle>
//         </CardHeader>
//         <CardContent>
//           <ul className="space-y-2">
//             <li>Cust-001 - High</li>
//             <li>Cust-002 - Medium</li>
//             <li>Cust-003 - High</li>
//           </ul>
//         </CardContent>
//       </Card>
//     </div>
//   );
// }

// // ---------------- ALERTS ----------------
// function AlertsSection() {
//   var chartConfig = {};

//   for (let i = 0; i < riskData?.length; i++) {
//     chartConfig[`${riskData[i]?.name}`] = {
//       label: riskData[i]?.name,
//     };
//   }
//   return (
//     <div className="grid md:grid-cols-2 gap-6">
//       <Card>
//         <CardHeader>
//           <CardTitle>Alerts Trend</CardTitle>
//         </CardHeader>
//         <CardContent className="p-4 pt-0">
//           <ChartContainer config={chartConfig} className="w-full max-h-[250px]">
//             <LineChart data={alertTrend}>
//               <XAxis dataKey="name" />
//               <YAxis />
//               <Tooltip />
//               <Line dataKey="alerts" stroke="#8884d8" />
//             </LineChart>
//           </ChartContainer>
//         </CardContent>
//       </Card>

//       <Card>
//         <CardHeader>
//           <CardTitle>Alerts by Type</CardTitle>
//         </CardHeader>
//         <CardContent className="p-4 pt-0">
//           <ChartContainer config={chartConfig} className="w-full max-h-[250px]">
//             <BarChart accessibilityLayer data={alertTypes}>
//               <CartesianGrid
//                 vertical={false}
//                 className="!stroke-border group-hover:dark:!stroke-muted-foreground"
//               />
//               <XAxis
//                 dataKey="name"
//                 tickLine={false}
//                 tickMargin={10}
//                 axisLine={false}
//               />
//               <YAxis allowDecimals={false} />
//               <ChartTooltip
//                 content={
//                   <ChartTooltipContent
//                     hideLabel
//                     className="w-[180px]"
//                     formatter={(value, name, item, index) => (
//                       <>
//                         {/* {index === 0 && (
//                             <div className="mb-1 flex basis-full items-center text-xs font-bold text-foreground">
//                               {item?.payload?.name}
//                             </div>
//                           )} */}
//                         <div
//                           className="h-2.5 w-2.5 shrink-0 rounded-[2px] bg-[--color-bg]"
//                           style={{
//                             "--color-bg": `var(--color-${name})`,
//                           }}
//                         />
//                         {item?.payload?.name}
//                         <div className="ml-auto flex items-baseline gap-0.5 font-mono font-medium tabular-nums text-foreground">
//                           {Number(value)}
//                         </div>
//                       </>
//                     )}
//                   />
//                 }
//                 cursor={false}
//               />
//               <Bar
//                 dataKey="value"
//                 // radius={4}
//                 stackId="a"
//                 // radius={[0, 0, 0, 0]}
//                 shape={(props) => {
//                   const { payload, ...rest } = props;
//                   const radius = [4, 4, 0, 0];
//                   return <Rectangle {...rest} radius={radius} />;
//                 }}
//                 className="hover:cursor-pointer"
//               />
//               <ChartLegend
//                 content={<ChartLegendContent />}
//                 className="-translate-y-2 flex-wrap gap-2 [&>*]:basis-1/4 [&>*]:justify-center"
//               />
//             </BarChart>
//           </ChartContainer>
//         </CardContent>
//       </Card>
//     </div>
//   );
// }

// // ---------------- CASES ----------------

// function CaseSection() {
//   const cases = [
//     { id: "C-001", status: "Open", owner: "John", days: 3 },
//     { id: "C-002", status: "Closed", owner: "Sara", days: 6 },
//     { id: "C-003", status: "Escalated", owner: "Mike", days: 10 },
//   ];

//   const caseColumns = [
//     {
//       dataField: "id",
//       text: "ID",
//       headerClasses: THClasses,
//       classes: TDClasses,
//     },
//     {
//       dataField: "status",
//       text: "Status",
//       headerClasses: THClasses,
//       classes: TDClasses,
//     },
//     {
//       dataField: "owner",
//       text: "Owner",
//       headerClasses: THClasses,
//       classes: TDClasses,
//     },
//     {
//       dataField: "days",
//       text: "Days Open",
//       headerClasses: THClasses,
//       classes: TDClasses,
//     },
//   ];

//   return (
//     <div className="space-y-6">
//       <div className="grid md:grid-cols-3 gap-4">
//         <KPI title="Open Cases" value="120" status="medium" />
//         <KPI title="Closed Cases" value="80" status="low" />
//         <KPI title="Escalated" value="10" status="high" />
//       </div>

//       <Card>
//         <CardHeader>
//           <CardTitle>Case List</CardTitle>
//         </CardHeader>
//         <CardContent>
//           <div className="custom-table">
//             <div className="table-body-class">
//               <BootstrapTable
//                 keyField="incident_id"
//                 remote
//                 data={cases}
//                 columns={caseColumns}
//                 rowClasses={TRClasses}
//                 noDataIndication="No Data Found"
//                 classes={TableClasses}
//                 wrapperClasses={TableWrapClasses}
//               />
//             </div>
//           </div>
//         </CardContent>
//       </Card>
//     </div>
//   );
// }

// // ---------------- KYC ----------------
// function KycSection() {
//   const kycList = [
//     { name: "Alice", status: "Completed", risk: "Low" },
//     { name: "Bob", status: "Pending", risk: "High" },
//     { name: "Charlie", status: "EDD", risk: "Medium" },
//   ];

//   const kycColumns = [
//     {
//       dataField: "name",
//       text: "Name",
//       headerClasses: THClasses,
//       classes: TDClasses,
//     },
//     {
//       dataField: "status",
//       text: "Status",
//       headerClasses: THClasses,
//       classes: TDClasses,
//     },
//     {
//       dataField: "risk",
//       text: "Risk",
//       headerClasses: THClasses,
//       classes: TDClasses,
//     },
//   ];

//   return (
//     <div className="space-y-6">
//       <div className="grid md:grid-cols-2 gap-4">
//         <Card>
//           <CardHeader>
//             <CardTitle>KYC Completion</CardTitle>
//           </CardHeader>
//           <CardContent>
//             <div className="w-full bg-gray-200 rounded h-4">
//               <div
//                 className="bg-green-500 h-4 rounded"
//                 style={{ width: "98%" }}
//               />
//             </div>
//             <p className="mt-2 text-sm">98% Completed</p>
//           </CardContent>
//         </Card>

//         <Card>
//           <CardHeader>
//             <CardTitle>EDD Cases</CardTitle>
//           </CardHeader>
//           <CardContent>
//             <p className="text-2xl font-bold">45</p>
//           </CardContent>
//         </Card>
//       </div>

//       <Card>
//         <CardHeader>
//           <CardTitle>KYC Records</CardTitle>
//         </CardHeader>
//         <CardContent>
//           <div className="custom-table">
//             <div className="table-body-class">
//               <BootstrapTable
//                 keyField="incident_id"
//                 remote
//                 data={kycList}
//                 columns={kycColumns}
//                 rowClasses={TRClasses}
//                 noDataIndication="No Data Found"
//                 classes={TableClasses}
//                 wrapperClasses={TableWrapClasses}
//               />
//             </div>
//           </div>
//         </CardContent>
//       </Card>
//     </div>
//   );
// }

// // ---------------- COMPLIANCE ----------------
// function ComplianceSection() {
//   const audits = [
//     { issue: "Missing KYC", severity: "High", status: "Open" },
//     { issue: "Late SAR", severity: "Medium", status: "Closed" },
//   ];

//   const auditColumns = [
//     {
//       dataField: "issue",
//       text: "Issue",
//       headerClasses: THClasses,
//       classes: TDClasses,
//     },
//     {
//       dataField: "severity",
//       text: "Severity",
//       headerClasses: THClasses,
//       classes: TDClasses,
//     },
//     {
//       dataField: "status",
//       text: "Status",
//       headerClasses: THClasses,
//       classes: TDClasses,
//     },
//   ];

//   return (
//     <div className="space-y-6">
//       <div className="grid md:grid-cols-3 gap-4">
//         <KPI title="Policy Breaches" value="3" status="high" />
//         <KPI title="Audit Findings" value="7" status="medium" />
//         <KPI title="Training %" value="92%" status="low" />
//       </div>

//       <Card>
//         <CardHeader>
//           <CardTitle>Audit Findings</CardTitle>
//         </CardHeader>
//         <CardContent>
//           <div className="custom-table">
//             <div className="table-body-class">
//               <BootstrapTable
//                 keyField="incident_id"
//                 remote
//                 data={audits}
//                 columns={auditColumns}
//                 rowClasses={TRClasses}
//                 noDataIndication="No Data Found"
//                 classes={TableClasses}
//                 wrapperClasses={TableWrapClasses}
//               />
//             </div>
//           </div>
//         </CardContent>
//       </Card>
//     </div>
//   );
// }
